import axios from 'axios'


const favlogFilename = (userId, month="") => {
  const monthKey = month.replace("/" , "")
  return `favlog/${userId}_fav${monthKey}.json`
}


const getObjFromGCS = async (filename) => {
  const url = `https://storage.googleapis.com/twistock.appspot.com/${filename}`
  try {
    const res = await axios.get(url)
    return res.data
  } catch (e) {
    return {}
  }
}


export const getFavDiscriptFileFromGCS = async (firebase_uid) => {
  const res = await getObjFromGCS(favlogFilename(firebase_uid))
  return res
}


export const getFavTweetsFileFromGCS = async (firebase_uid, month) => {
  const res = await getObjFromGCS(favlogFilename(firebase_uid, month))
  return res
}


export const updateFavlist = async (firebase_id, accessToken, accessTokenSecret,
                                    maxId="", minId="0", getFuncNum=70) => {
  const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/update_favlist"
  let apiParam = {
    params: {
      firebase_id: firebase_id,
      at: accessToken,
      ats: accessTokenSecret,
      min_id: minId,
      get_func_num: getFuncNum,
    }
  }
  if(maxId != "") apiParam.params["max_id"] = maxId
  try{
    const res = await axios.get(api_url, apiParam)
    return res.data
  } catch(e) {
    return false
  }
}


export const getInitFavUpdateInfo = (favDiscriptObj, current_date=new Date()) => {
  let retObj = {minId:"0", maxId:"", isInit:true, needUpdate:true}
  if(Object.keys(favDiscriptObj).length < 2) return retObj
  retObj.minId = favDiscriptObj.latest_tweetid
  retObj.isInit = false
  if("update_date" in favDiscriptObj){
    const updateDate = new Date(favDiscriptObj.update_date)
    const passedTimeHour = (current_date - updateDate)/(1000*60*60)
    if(passedTimeHour < 12) retObj.needUpdate = false
  }
  return retObj
}


export const updateOthersFavlist = async (userId, accessToken, accessTokenSecret,
                                          maxId="", minId="0", getFuncNum=70) => {
  const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/update_others_favlist"
  let apiParam = {
    params: {
      user_id: userId,
      at: accessToken,
      ats: accessTokenSecret,
      min_id: minId,
      get_func_num: getFuncNum,
    }
  }
  if(maxId != "") apiParam.params["max_id"] = maxId
  try{
    const res = await axios.get(api_url, apiParam)
    return res.data
  } catch(e) {
    return false
  }
}